export default class SeatCount {
  availableSeatCount = null
  totalSeatCount = null
  travelClass = ''
}
